import _defineProperty from '@babel/runtime/helpers/defineProperty';
import classNames from 'classnames';
import get from 'lodash-es/get';
import isEmpty from 'lodash-es/isEmpty';
import PropTypes from 'prop-types';
import React, { useCallback, useMemo } from 'react';
import { PropTypes as PropTypes$1 } from '@panneau/core';
import { getPathValue } from '@panneau/core/utils';
import Button from '@panneau/element-button';
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import isArray from 'lodash-es/isArray';

var propTypes$1 = {
  item: PropTypes.shape({
    id: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
  }),
  getItemLabel: PropTypes.func,
  getItemDescription: PropTypes.func,
  getItemImage: PropTypes.func,
  itemLabelPath: PropTypes.string,
  itemDescriptionPath: PropTypes.string,
  itemImagePath: PropTypes.string,
  itemLabelWithId: PropTypes.bool,
  onClickEdit: PropTypes.func,
  onClickRemove: PropTypes.func,
  editButtonLabel: PropTypes$1.message,
  removeButtonLabel: PropTypes$1.message,
  disabled: PropTypes.bool,
  className: PropTypes.string,
  children: PropTypes.node,
  header: PropTypes.node,
  footer: PropTypes.node
};
var defaultProps$1 = {
  item: null,
  getItemLabel: getPathValue,
  getItemDescription: getPathValue,
  getItemImage: getPathValue,
  itemLabelPath: 'label',
  itemDescriptionPath: null,
  itemImagePath: null,
  itemLabelWithId: false,
  onClickEdit: null,
  onClickRemove: null,
  editButtonLabel: null,
  removeButtonLabel: null,
  disabled: false,
  className: null,
  children: null,
  header: null,
  footer: null
};
var ResourceCard = function ResourceCard(_ref) {
  var item = _ref.item,
    itemLabelPath = _ref.itemLabelPath,
    itemDescriptionPath = _ref.itemDescriptionPath,
    itemImagePath = _ref.itemImagePath,
    itemLabelWithId = _ref.itemLabelWithId,
    initialGetItemLabel = _ref.getItemLabel,
    getItemDescription = _ref.getItemDescription,
    getItemImage = _ref.getItemImage,
    onClickEdit = _ref.onClickEdit,
    onClickRemove = _ref.onClickRemove,
    editButtonLabel = _ref.editButtonLabel,
    removeButtonLabel = _ref.removeButtonLabel,
    disabled = _ref.disabled,
    children = _ref.children,
    header = _ref.header,
    footer = _ref.footer,
    className = _ref.className;
  var getItemLabel = useCallback(function (it, path) {
    var id = get(it, 'id', null);
    if (itemLabelWithId) {
      var label = initialGetItemLabel(it, path);
      return label ? "".concat(label, " (#").concat(id, ")") : "#".concat(id);
    }
    return path !== null ? initialGetItemLabel(it, path) : "#".concat(id);
  }, [initialGetItemLabel, itemLabelWithId]);
  var itemLabel = item !== null ? getItemLabel(item, itemLabelPath) : null;
  var itemDescription = item !== null ? getItemDescription(item, itemDescriptionPath) : null;
  var itemImage = item !== null ? getItemImage(item, itemImagePath) : null;
  return /*#__PURE__*/React.createElement("div", {
    className: classNames(['card', _defineProperty(_defineProperty(_defineProperty({}, "bg-muted", disabled), "text-muted", disabled), className, className !== null)])
  }, header !== null ? /*#__PURE__*/React.createElement("div", {
    className: "card-header p-1 ps-2"
  }, header) : null, /*#__PURE__*/React.createElement("div", {
    className: "card-body p-1 pl-2"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center"
  }, itemImage !== null ? /*#__PURE__*/React.createElement("img", {
    src: itemImage,
    alt: itemLabel,
    className: "flex-shrink-0 me-2",
    width: "20"
  }) : null, /*#__PURE__*/React.createElement("div", {
    className: "flex-grow-1 ms-1"
  }, /*#__PURE__*/React.createElement("h6", {
    className: "m-0 text-break"
  }, itemLabel), !isEmpty(itemDescription) ? /*#__PURE__*/React.createElement("p", {
    className: "m-0 text-break"
  }, /*#__PURE__*/React.createElement("small", null, itemDescription)) : null), onClickEdit !== null ? /*#__PURE__*/React.createElement("div", {
    className: "ms-1"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    size: "sm",
    theme: "secondary",
    icon: "pencil-square",
    outline: disabled,
    onClick: onClickEdit,
    disabled: disabled
  }, editButtonLabel)) : null, onClickRemove !== null ? /*#__PURE__*/React.createElement("div", {
    className: "ms-1"
  }, /*#__PURE__*/React.createElement(Button, {
    type: "button",
    size: "sm",
    theme: "secondary",
    icon: "x-lg",
    outline: disabled,
    onClick: onClickRemove,
    disabled: disabled
  }, removeButtonLabel)) : null), children), footer !== null ? /*#__PURE__*/React.createElement("div", {
    className: "card-footer p-1 ps-2"
  }, footer) : null);
};
ResourceCard.propTypes = propTypes$1;
ResourceCard.defaultProps = defaultProps$1;

var styles = {"container":"panneau-element-resource-card-container"};

var _excluded = ["value", "className", "cardClassName"];
var propTypes = {
  value: PropTypes.oneOfType([PropTypes.array, PropTypes.shape({
    filename: PropTypes.string,
    size: PropTypes.number,
    url: PropTypes.string
  })]),
  className: PropTypes.string,
  cardClassName: PropTypes.string
};
var defaultProps = {
  value: null,
  className: null,
  cardClassName: null
};
var ResourceCards = function ResourceCards(_ref) {
  var value = _ref.value,
    className = _ref.className,
    cardClassName = _ref.cardClassName,
    props = _objectWithoutProperties(_ref, _excluded);
  var values = useMemo(function () {
    if (isArray(value)) {
      return value.filter(function (v) {
        return v !== null;
      });
    }
    return value !== null ? [value] : [];
  }, [value]);
  return /*#__PURE__*/React.createElement("div", {
    className: classNames([styles.container, _defineProperty({}, className, className !== null)])
  }, values.map(function (val, idx) {
    return /*#__PURE__*/React.createElement(ResourceCard, Object.assign({
      key: "resource-card-".concat(idx + 1, "-").concat(val !== null ? val === null || val === void 0 ? void 0 : val.id : null),
      className: classNames([styles.card, _defineProperty({}, cardClassName, cardClassName !== null)])
    }, props, {
      item: val,
      index: idx
    }));
  }));
};
ResourceCards.propTypes = propTypes;
ResourceCards.defaultProps = defaultProps;

export { ResourceCards, ResourceCard as default };
